// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__325lM","title":"AfterFrontImage_title__2xn8w"};